/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleDiagnosticsControllerLookupInvitesByEmailQueryResponse, TrimbleDiagnosticsControllerLookupInvitesByEmailQueryParams, TrimbleDiagnosticsControllerLookupInvitesByEmail400, TrimbleDiagnosticsControllerLookupInvitesByEmail401, TrimbleDiagnosticsControllerLookupInvitesByEmail403, TrimbleDiagnosticsControllerLookupInvitesByEmail404 } from "../../models/trimbleDiagnosticsController/TrimbleDiagnosticsControllerLookupInvitesByEmail";

function getTrimbleDiagnosticsControllerLookupInvitesByEmailUrl() {
  const res = { method: 'GET', url: `/api/v1/trimble-invite-diagnostics` as const }  
  return res
}

/**
 * @summary Diagnose Document Crunch and IAM invitations for an email
 * {@link /api/v1/trimble-invite-diagnostics}
 */
export async function trimbleDiagnosticsControllerLookupInvitesByEmail(params: TrimbleDiagnosticsControllerLookupInvitesByEmailQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TrimbleDiagnosticsControllerLookupInvitesByEmailQueryResponse, ResponseErrorConfig<TrimbleDiagnosticsControllerLookupInvitesByEmail400 | TrimbleDiagnosticsControllerLookupInvitesByEmail401 | TrimbleDiagnosticsControllerLookupInvitesByEmail403 | TrimbleDiagnosticsControllerLookupInvitesByEmail404>, unknown>({ method : "GET", url : getTrimbleDiagnosticsControllerLookupInvitesByEmailUrl().url.toString(), params, ... requestConfig })  
  return res.data
}